import { Injectable, Injector } from '@angular/core';
import { Logs } from '../../models/logs.model';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthenticationService } from '../authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LogBuilderService {
  private appVersion = environment.appVersion;
  private _router?: Router;
  private _authenticationService?: AuthenticationService;
  private _deviceDetectorService?: DeviceDetectorService;
  private readonly APP_NAME = 'Web Order';

  constructor(
    private _injector: Injector
  ) {  }

  public build(error: any): Logs {

    this._router = this._injector.get(Router);
    this._deviceDetectorService = this._injector.get(DeviceDetectorService);
    this._authenticationService = this._injector.get(AuthenticationService);

    if (error instanceof HttpErrorResponse) {
      return this.buildHttpErrorResponse(error);
    }

    return this.buildGenericLog(error);
  }

  public buildGenericLog(error: any) {
    const newErrorLog: Logs = {
      autoId: 0,
      userId: this._authenticationService?.getUserId() ?? 0,
      application: this.APP_NAME,
      browser: `${this._deviceDetectorService?.browser} ${this._deviceDetectorService?.browser_version}`,
      kiosk: this.appVersion,
      locationId: 0,
      webpage: this._router?.url || '',
      information: error.message,
      exceptionDetails: error.stack,
    };
    return newErrorLog;
  }

  public buildHttpErrorResponse(error: HttpErrorResponse): Logs {
    const newErrorLog: Logs = {
      autoId: 0,
      userId: this._authenticationService?.getUserId() ?? 0,
      application: this.APP_NAME,
      browser: `${this._deviceDetectorService?.browser} ${this._deviceDetectorService?.browser_version}`,
      kiosk: this.appVersion,
      locationId: 0,
      webpage: this._router?.url || '',
      information: error.message,
      exceptionDetails: JSON.stringify(error)
    }
    return newErrorLog;
  }
}
